import { createCommentSchema, updateCommentSchema, type CommentSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type Comment = CommentSchema;
export type CreateComment = typeof createCommentSchema._type;
export type UpdateComment = typeof updateCommentSchema._type;

/**
 * Create a new comment
 */
export const createComment = async (commentData: CreateComment): Promise<{ comment: Comment }> => {
  const response = await apiClient.post<{ comment: Comment }>("/api/comment", commentData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

/**
 * Get all comments for a project
 */
export const getCommentsByProject = async (projectId: string): Promise<{ comments: Comment[] }> => {
  const response = await apiClient.get<{ comments: Comment[] }>(`/api/comment/project/${projectId}`);
  return response.data;
};

/**
 * Get a single comment by ID
 */
export const getComment = async (commentId: string): Promise<{ comment: Comment }> => {
  const response = await apiClient.get<{ comment: Comment }>(`/api/comment/${commentId}`);
  return response.data;
};

/**
 * Update an existing comment
 */
export const updateComment = async (commentId: string, commentData: UpdateComment): Promise<{ comment: Comment }> => {
  const response = await apiClient.put<{ comment: Comment }>(`/api/comment/${commentId}`, commentData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

/**
 * Delete a comment
 */
export const deleteComment = async (commentId: string): Promise<{ message: string; comment: Comment }> => {
  const response = await apiClient.delete<{ message: string; comment: Comment }>(`/api/comment/${commentId}`);
  return response.data;
};
